import React from 'react';
import { t } from '@lingui/macro';
import dayjs from 'dayjs';
import FormatNumber from "bukku/components/FormatNumber";
import TransactionLink from "bukku/components/TransactionLink";
import { Type } from "bukku/redux/Transaction/helper";
import AmountTd from "bukku/components/Table/Common/AmountTd";
import { store } from '../../../../../redux/store';
import ContactName from '../../../../../components/Columns/Reports/Common/ContactName';
import Tags from '../../../../../components/Table/Cell/Tags';
import BukkuTooltip from '../../../../../components/Tooltip';

const getColClassName = columnType => {
    switch (columnType) {
        case 'category_total':
            return 'report-category-total-col';
        default:
            return null;
    }
};

export const ColRenderer = {
    renderDate: (text, record, type) => {
        let text2;
        if (record.column_type) {
            text2 = 'TOTAL';
        }
        else {
            text2 = <TransactionLink
                transaction={{ type, id: record.id }}
                label={dayjs(text).format('DD/MM/YYYY')}
            />;
        }

        return text2;
    },

    renderNumber: (text, record, type) => <TransactionLink
        transaction={{ type, id: record.id }}
        label={text}
    />,

    renderInvoiceNumber: (text, record) => {
        if (!record.column_type) {
            if (record.invoice_id) {
                return <TransactionLink
                    transaction={{ type: Type.sale_invoice, id: record.invoice_id }}
                    label={text}
                />;
            }
            return t`Overpayment`;
        }
        return null;
    },

    renderBillNumber: (text, record) => {
        if (!record.column_type) {
            if (record.bill_id) {
                return <TransactionLink
                    transaction={{ type: Type.purchase_bill, id: record.bill_id }}
                    label={text}
                />;
            }
            return t`Overpayment`;
        }
        return null;
    },

    renderTitle: (text, record) => {
        if (!record.column_type) {
            return (
                <span>
                    <BukkuTooltip title={text} placement="topLeft">
                        {text || '-'}
                    </BukkuTooltip>
                </span>
            );
        }

        return null;
    },

    renderText: (text, record) => {
        if (!record.column_type)
            return text || '-';

        return null;
    },

    renderContact: (contactName, record) => {
        if (!record.column_type) {
            const { contact_id, contact_code } = record;
            return (
                <ContactName
                    contact_id={contact_id}
                    contact_name={contactName || '-'}
                    contact_code={contact_code || ''}
                />
            );
        }
        return null;
    },

    renderPaymentMode: (text, record) => {
        if (!record.column_type) {
            switch (text) {
                case 'cash':
                    return t`Cash Term`;
                case 'credit':
                    return t`Credit Term`;
                case 'claim':
                    return t`Expense Claim`;
                default:
                    return '-';
            }
        }
        return null;
    },

    renderPaymentMethod: (text, record) => {
        if (!record.column_type)
            return record.payment_method_name || '-';

        return null;
    },

    renderExchangeRate: (text, record) => {
        if (!record.column_type)
            return <FormatNumber amount={text} dp={6} dp2={8} />;
        return null;
    },

    onCell: record => ({
        className: getColClassName(record.column_type),
    }),

    renderBaseAmount: text => {
        const { Report } = store.getState();
        const { reportData } = Report;

        return <AmountTd currency_symbol={reportData.company.currency_symbol} amount={text} />;
    },

    renderAmount: (text, record) => {
        if (!record.column_type)
            return <AmountTd currency_code={record.currency_code} amount={text} />;
        return null;
    },

    renderCreatedAt: (text, record) => {
        if (!record.column_type)
            return text ? dayjs(text).format('DD/MM/YYYY hh:mm a') : '-';
        return null;
    },

    renderTags: (text, record) => {
        if (!record.column_type)
            return <Tags list={text} />;
        return null;
    },

    renderPaymentStatus: (text, record) => {
        const isInvoiceBill = record.type === Type.sale_invoice ||
            record.type === Type.purchase_bill;
        const isCreditNote = record.type === Type.purchase_credit_note ||
            record.type === Type.sale_credit_note;

        if (!record.column_type) {
            console.log('aa renderPaymentStatus', {text, record, isInvoiceBill, isCreditNote});
            switch (text) {
                case 'APPLIED':
                    return t`Applied`;
                case 'PAID':
                    if (isInvoiceBill)
                        return t`Paid`;
                    if (isCreditNote)
                        return t`Applied`;
                    break;
                case 'OUTSTANDING':
                    return t`Outstanding`;
                default:
                    return '-';
            }
        }
        return null;
    },
};
